module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/giftcard/bg2-10c7ec288da462932b1ee4033a704add.jpg";